import {
  Box,
  Button,
  Typography,
  ThemeProvider,
  createTheme,
  Avatar,
  Card,
  CardMedia,
  CardContent,
  Grid,
  IconButton,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import '../../style/customStyle.css';
import { useEffect, useRef, useState } from 'react';
import ApiService from '../../_services/ApiService';
import { PulsateCardSkeleton } from '../../components/reusableComponents/SkeletonCard';
import NoResults from '../../components/reusableComponents/NoResults';
import playlist from '../../img/Frame 48096170.png'
import { getDateAsPerFormat } from '../../_helpers/reusablefunctions/dateSetter';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const theme = createTheme({
  breakpoints: { values: { xs: 0, sm: 600, md: 960, lg: 1280, xl: 1920 } },
});

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { studio_id } = useSelector((s) => s.userData.userData);
  const [skeleton, setSekeleton] = useState(true)
  const [latestRelease, setLatestRelease] = useState([])
  const [countList, setCountList] = useState([])
  let totalReleases = 0;
  const scrollRef = useRef(null);
  const [showPrev, setShowPrev] = useState(false);
  const [showNext, setShowNext] = useState(false);

  const checkScrollButtons = () => {
    const el = scrollRef.current;
    if (!el) return;

    setShowPrev(el.scrollLeft > 0);
    setShowNext(el.scrollLeft + el.clientWidth < el.scrollWidth);
  };

  useEffect(() => {
    checkScrollButtons();
    const el = scrollRef.current;
    if (el) {
      el.addEventListener('scroll', checkScrollButtons);
      return () => el.removeEventListener('scroll', checkScrollButtons);
    }
  }, [latestRelease]);

  const scrollBy = (offset) => {
    scrollRef.current.scrollBy({ left: offset, behavior: 'smooth' });
  };

  useEffect(() => {
    if (!studio_id) return;

    const fetchData = async () => {
      try {
        const [albumRes, countRes] = await Promise.all([
          ApiService.get('albumMeta', { limit: 10, offset: 0, song_status: 'Released' }, studio_id),
          ApiService.get('dashboardCount', {}, studio_id),
        ]);

        let latestReleases = [];

        if ([200, 201].includes(albumRes?.status)) {
          const albumResults = albumRes?.data?.results;
          totalReleases = albumRes?.data?.total_count;

          // Check if results is an object with items and total_count
          if (albumResults?.items && typeof albumResults.total_count === 'number') {
            latestReleases = albumResults.items;
            // totalReleases = albumResults.total_count;
          }
          // Else assume results is an array
          else if (Array.isArray(albumResults)) {
            latestReleases = albumResults;
            // totalReleases = albumResults.length;
          }

          setLatestRelease(latestReleases);
        }

        if ([200, 201].includes(countRes?.status)) {
          const countData = countRes?.data;

          setCountList([
            {
              label: 'Available Balance',
              value: (<>
                <CurrencyRupeeIcon />
                {countData?.revenue_summary?.net_revenue ?? 0}
              </>),
              subtitle: countData?.revenue_summary?.updated_at
                ? `Last update on ${getDateAsPerFormat(countData?.revenue_summary?.updated_at, 'DD Mon, YYYY')}`
                : '',
              cardbg: '#F1E7E8',
              bgcolor: '#000',
            },
            {
              label: 'Last Pay-out',
              value: (
                <>
                  <CurrencyRupeeIcon />
                  {countData?.last_payment?.amount_paid ?? 0}
                </>
              ),
              subtitle: countData?.last_payment?.requested_date
                ? `Last update on ${getDateAsPerFormat(countData?.last_payment?.requested_date, 'DD Mon, YYYY')}`
                : '',
              cardbg: '#E6EEEF',
              bgcolor: '#ED3237',
            },
            {
              label: 'Total Releases',
              value: totalReleases,
              // subtitle: `${countData?.latest_month_summary?.month || ''} ${countData?.latest_month_summary?.year || ''}`,
              cardbg: '#F1EAE7',
              bgcolor: '#000',
            },
          ]);
        }

      } catch (err) {
        console.error('Dashboard data fetch error:', err);
      } finally {
        setSekeleton(false);
      }
    };

    fetchData();
  }, [studio_id]);

  const handleClick = (e, data) => {
    e.stopPropagation()
    e.preventDefault()
    navigate(`/addrelease/${data.album_id}`);
  }

  return (
    <ThemeProvider theme={theme}>


      {/* -------------- payout count details -------------- */}
      <Box sx={{ display: 'flex', gap: '20px', mt: 3, flexWrap: { xs: "wrap", md: "nowrap" }, }}>
        {countList.map((item, index) => (<Box key={index}
          sx={{
            width: { xs: "100%", md: "32.5%" },
            display: "flex",
            alignItems: "center",
            gap: "10px",
            backgroundColor: item?.cardbg,
            padding: "15px",
            borderRadius: "16px",
          }}
        >
          <Box display={'flex'} gap={1} flexDirection={'column'} >
            <Typography variant="h6" fontWeight={"500"}>
              {item?.label}
            </Typography>
            <Typography
              className=""
              variant="h4"
              fontSize={"25px"}
              fontWeight={"600"}
              sx={{ color: item?.bgcolor }}
            >
              {item?.value}
            </Typography>
            <Typography variant="subtitle" fontSize={"14px"} >
              {item?.subtitle}
            </Typography>
          </Box>
        </Box>))}
      </Box>

      {/* ------------------ releseas detailssss-------------- */}

      <Box sx={{ py: 2, mb: 5 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h6" fontWeight={600}>
            Latest Releases
          </Typography>
          <Button variant="contained" onClick={(e) => navigate('/releasealbum')}
            className="gn-actionbtn text-white rounded-pill"
            sx={{ textTransform: 'none' }}>
            See All
          </Button>
        </Box>
        <Box sx={{ position: 'relative', width: '100%', maxWidth: 1200, mx: 'auto' }}>
          {showPrev && (
            <IconButton
              onClick={() => scrollBy(-300)}
              sx={{
                position: 'absolute',
                top: '50%',
                left: 0,
                transform: 'translateY(-50%)',
                zIndex: 1,
                backgroundColor: '#fff',
                boxShadow: 2,
              }}
            >
              <ChevronLeftIcon />
            </IconButton>
          )}
          {showNext && (
            <IconButton
              onClick={() => scrollBy(300)}
              sx={{
                position: 'absolute',
                top: '50%',
                right: 0,
                transform: 'translateY(-50%)',
                zIndex: 1,
                backgroundColor: '#fff',
                boxShadow: 2,
              }}
            >
              <ChevronRightIcon />
            </IconButton>
          )}

          <Box
            sx={{
              display: 'flex',
              overflowX: 'auto',
              gap: 2,
              pb: 1,
              '&::-webkit-scrollbar': {
                display: 'none',
              },
              // '-ms-overflow-style': 'none', // IE & Edge
              // 'scrollbar-width': 'none', // Firefox
            }}
          >
            {skeleton ?
              <PulsateCardSkeleton />
              :
              latestRelease.length ? latestRelease.map((release, index) => (
                <Card
                  onClick={(e) => handleClick(e, release)}
                  key={index}
                  sx={{
                    minWidth: 236,
                    maxWidth: 236,
                    borderRadius: 2,
                    overflow: 'hidden',
                    flexShrink: 0,
                    padding: '10px',
                    cursor: 'pointer'
                  }}
                >
                  <Box>
                    <CardMedia component="img" image={release.resized_cover?.thumbnail300x150
                      ? `${process.env.REACT_APP_SONGAPIURL_MEDIA}${release.resized_cover?.thumbnail300x150}`
                      : release.cover_image ? `${process.env.REACT_APP_SONGAPIURL_MEDIA}/media/${release.cover_image}`
                        : playlist} alt={release.album_name} height={'220px'} sx={{ objectFit: 'inherit' }} />
                  </Box>
                  <CardContent className='p-0' >
                    <Typography variant="subtitle1" fontWeight={500} noWrap>
                      {release.album_name}
                    </Typography>
                  </CardContent>
                </Card>
              )) : <NoResults />}
          </Box>

        </Box>
      </Box>

    </ThemeProvider>
  );
};

export default Dashboard;
